import { IAnimalValueLabelElement, ValueLabelElement } from '@ps20-frontend/frontend-models';
import { DogBreed, Domaene } from '@ps20/bff-models';

export const toBreedList = (breeds: Array<Domaene | DogBreed>): IAnimalValueLabelElement[] =>
  breeds
    .map(breed => {
      const element: IAnimalValueLabelElement = { label: breed.text, value: breed.wert };
      const motherBreed = (breed as DogBreed).motherBreed;
      return motherBreed == null
        ? element
        : { ...element, motherBreed: { label: motherBreed.text, value: motherBreed.wert } };
    })
    .sort((a, b) => a.label.localeCompare(b.label));

export const isListedBreed = (code: string, breeds: ValueLabelElement[]): boolean =>
  breeds.some(breed => breed.value === code);
